import ApiService from "@/common/api/api.service";

const RH = {

    adicionar(form, realizado,endpoint){
        return ApiService.post(`${endpoint}/recurso-humano-${realizado ? 'realizado' : 'previsto'}`, form);
    },

    salvar(form, realizado,endpoint){
        return ApiService.put(`${endpoint}/recurso-humano-${realizado ? 'realizado' : 'previsto'}`, form);
    },

    listar(id, realizado, endpoint,nomeId){
        return ApiService.get(`${endpoint}/recurso-humano-${realizado ? 'realizado' : 'previsto'}?${nomeId}=${id}`);
    },

    deletar(form, realizado){
        return ApiService.delete(`ProjetoGestao/recurso-humano-${realizado ? 'realizado' : 'previsto'}`, form);
    }
}

export default RH;
